import * as analyticHelper from '@/lib/analytic-helper';
import Vue from 'vue';
import AxPowerbar from './AxPowerbar.vue';
import VueHotkey from 'v-hotkey';
import Vuex from 'vuex';
import { Store } from 'vuex';
Vue.use(Vuex);
Vue.use(VueHotkey)
export interface IPermission {
    hidden: boolean;
}
interface IGroupHeader {
    caption: string;
    type: 'GroupHeader';
    permission?: IPermission;
}
interface IColumnBreak {
    type: 'ColumnBreak';
}

type RouteTarget = 'modal' | 'window' | 'default' | undefined;
export interface IMenuLink {
    type?: undefined | 'default';
    caption: string;
    routeUrl: string;
    routeTarget: RouteTarget;
    menuItems?: IMenuItem[];
    events?: IEvent;
    modal?: boolean;
}

export type IMenuItemsWrapper = {
    menuItems: IMenuItem[];
}

export type IMenuItem = IMenuLink | IGroupHeader | IColumnBreak;

export interface IComputedSubMenuData {
    type: 'GroupHeader';
    caption: string;
    permission?: IPermission;
    items: IMenuItem[];
}

export interface IMenuBar {
    caption?: string;
    code: string;
    menus?: IMenu[];
}

export interface IMenu {
    caption: string;
    menuItems: IMenuItem[];
}
export interface IEvent {
    caption: string,
    items: IMenuLink[],
    permission?: IPermission,
    type?: string
}

export interface IGroupedItems {
    caption: string;
    items: IMenuLink[];
}

export default Vue.extend({
    name: 'ax-powerbar',
    components: {
        AxPowerbar,
    },
    store: new Store({}),
    props: {
        accessToken: {
            type: String,
        },
        username: {
            type: String,
            required: true,
        },
        options: {
            type: Object,
            default: () => ({
                clientViewPath: 'https://client.class.com.au/',
                baseUrl: 'https://app.class.com.au/',
                homeUrl: 'https://app.class.com.au/',
                classAgent: {
                    url: 'https://scout.class.com.au/',
                    enabled: true
                },
                enableDapSso: false,
                fundSearchApiEndpoint: 'https://search-api.class-test.com.au/api/b/Flora/search/entities',
                integrationConfig: null,
                entityChipData: null,
                navData: {
                    pageTitle: 'Home',
                    code: 'Home',
                },
                eventsData: null,
                enableHelpPanel: false,
            }),
        },
    },
    render(createElement) {
        return createElement(AxPowerbar, {
            props: {
                accessToken: this.accessToken,

                username: this.username,
                enableDapSso: this.options?.enableDapSso,
                clientViewPath: this.options?.clientViewPath,
                classAgent: this.options?.classAgent,
                navData: this.options?.navData,
                eventsData: this.options?.eventsData,
                baseUrl: this.options?.baseUrl,
                homeUrl: this.options?.homeUrl,
                integrationConfig: this.options?.integrationConfig,
                entityChipData: this.options?.entityChipData,
                fundSearchApiEndpoint: this.options?.fundSearchApiEndpoint,
                enableHelpPanel: this.options?.enableHelpPanel,
            },
            on: {
                newFeatureToggled: (payload: any) => {
                    this.$emit('newFeatureToggled', payload);
                    analyticHelper.powerbarSwitchEvent({ newValue: false });
                },
                navigate: (payload: any) => {
                  this.$emit('navigate', payload);
                  analyticHelper.powerbarSearchItemActivatedEvent(payload);
                },
                searchBoxFocused: (payload: any) => {
                  this.$emit('searchBoxFocused', payload);
                },
            },
        });
    },
});
